import moment from "moment";


export default function SymbolCard({ item }) {
  const cellStyle = {
    flex: 1,
    textAlign: "center",
    fontWeight: 600,
    color: "var(--text)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontSize: 12,
  };

  const isAllowed = item.allow === 1; // change this field according to your DB
  const isBlock = item.block === 1; // change this field according to your DB

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        borderBottom: `2px solid var(--hover)`,
        height: 40,
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 10,
        backgroundColor: !isAllowed ? "var(--background)" : "transparent",
      }}
    >
      {/* Overlay if symbol is not allowed */}
      {!isAllowed && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0, // leave space for Edit button
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.55)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 14,
            color: "white",
            textTransform: "uppercase",
            pointerEvents: "none",
          }}
        >
          🚫 Not Allowed
        </div>
      )}

      {/* Blocked Overlay (only covers row data, not edit button) */}
      {isBlock && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0, // leave space for Edit button (~80px wide)
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.55)", // dark overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 14,
            color: "white",
            textTransform: "uppercase",
            pointerEvents: "none", // allow click-through to Edit
          }}
        >
          🚫 Blocked
        </div>
      )}

      {/* Row Data */}
      <div style={{ ...cellStyle, flex: 1 }}>{item.symbol}</div>
      <div style={{ ...cellStyle, flex: 1 }}>
        {moment(item.expiry_date).format("DD-MMM")}
      </div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.min_qty}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.qty_per_order}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.total_quantity}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.lot_size}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.margin}</div>
    </div>
  );
}
